// extracted by mini-css-extract-plugin
export default {"link":"NavBarItem_link__rcuxk"};